import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
import vuexStorage from '../store/index.js'
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
  new Vue().$notify({
      title: title,
      message: content,
      type: 'error',
      position: 'bottom-right'
  })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction d'activation de template
function activerTemplate(id,active){
  if(id!=null){
    if(active){
      active=0;
    }else{
      active=1;
    }
    this.axios.post(conf.server+"/api/activeTemplate",{id:id, active:active} ,{withCredentials:true})
      .then(() => {
        for(var i=0;i<this.templates.length;i++){
          if(this.templates[i].value==id){
            this.templates[i].active=active;
          }
        }
      })
      .catch((error) => {
        if(error.response != undefined){
          toasterError(`Activation de template impossible`,'Activation de template')
          if(error.response.data.route!=null){
            this.$router.push(error.response.data.route);
          }
        }else{
          toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      })
  }else{
    toasterError(`Le template ne peut être activé`,'Activation de template')
  }
}

//Fonction qui permet d'ajouter la class active au menu profil du client
function activeClassMenuProfil(){
  var url = window.location.pathname;
  var classActive = document.getElementById("navigation");
  for(var i=0;i<classActive.children.length;i++){
    classActive.children[i].children[0].classList.remove("active");
    classActive.children[i].children[0].classList.remove("router-link-exact-active");
    classActive.children[i].children[0].classList.remove("router-link-active");

    var path = classActive.children[i].children[0].getAttribute("href");
    if(path==url){
      classActive.children[i].children[0].classList.add("active");
      classActive.children[i].children[0].classList.add("router-link-exact-active");
      classActive.children[i].children[0].classList.add("router-link-active");
    }
  }
}

//Fonction d'ajout de produit à un devis
function addProduct (item){
  if(this.selectedTypeLine == 2){
    var find = false
    for(var i=0; i< this.products.length; i++){
      if(item.id == this.products[i].id){
        this.products[i].qty = parseInt(item.qty) + parseInt(this.products[i].qty)
        this.products[i].totalHt = Number.parseFloat(this.products[i].qty*item.prixUnitaire).toFixed(2)
        find = true
      }
    }
    if(!find){
      this.products.push({id: item.id, ref: item.ref, label: item.label, description: item.description, tva: Number.parseFloat(item.tva).toFixed(2), prixUnitaire: item.prixUnitaire, qty: item.qty, reduction: item.reduction, totalHt: Number.parseFloat(item.qty*item.prixUnitaire).toFixed(2), productType: item.type, start: this.limitedService.start, finish: this.limitedService.finish})
    }
  }else{
    if(this.selectedProductType == 1){
      if(this.limitedService.start>this.limitedService.finish){
        this.$bvToast.toast(`La date début doit être supérieure à la date de fin du service`, {
          title: 'Service à durée limitée',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        })
      }else{
        this.products.push({id: item.id, label: item.label, tva: Number.parseFloat(item.tva).toFixed(2), prixUnitaire: item.prixUnitaire, qty: item.qty, reduction: item.reduction, totalHt: Number.parseFloat(item.qty*item.prixUnitaire).toFixed(2), productType: this.selectedProductType, start: this.limitedService.start, finish: this.limitedService.finish})
      }
    }else{
      this.products.push({id: item.id, label: item.label, tva: Number.parseFloat(item.tva).toFixed(2), prixUnitaire: item.prixUnitaire, qty: item.qty, reduction: item.reduction, totalHt: Number.parseFloat(item.qty*item.prixUnitaire).toFixed(2), productType: this.selectedProductType})
    }
  }
  this.deleteProduct()
}

//Fonction de modification des infos perso du client
function changeInfoPerso(infoClients, infoPerso){
  var key = Object.keys(infoPerso);
  var changeInfo = [];
  var j = 0;
  for(var i=0;i<key.length;i++){
    if((infoClients[key[i]] != infoPerso[key[i]])&&(key[i]!="array_options")){
      changeInfo[j] = new Array(2);
      changeInfo[j][0] = key[i];
      changeInfo[j][1] = infoPerso[key[i]];
      j++;
    }
  }
  
  if(changeInfo){
    this.axios.post(conf.server+"/api/changeInfoPerso",changeInfo,{withCredentials:true})
    .then((response) => {
      alert(response.data);
    })
    .catch((error) => {
      if(error.response != undefined){
        this.$bvToast.toast(`Changement d'information impossible`, {
          title: 'Changement d\'informations',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        })
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
  }
}

//Fonction envoi mail changement de mot de passe
function changePassOublie(){
  this.axios.post(conf.server+"/api/createToken",{email:this.loginOublie},{withCredentials:true})
  .then(() => {
    this.$bvToast.toast(`Un lien vient de vous être envoyé dans votre boîte mail`, {
      title: 'Changement de mot de passe',
      toaster: 'b-toaster-bottom-right',
      variant: 'success',
      autoHideDelay: 2500,
      appendToast: true,
      solid: true
    })
    this.$router.push("../login");
  })
  .catch((error)=>{
    if(error.response != undefined){
      toasterError(`Changement de mot de passe impossible`,'Changement de mot de passe')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      this.$router.push("../login");
    }
  })
}

//Fonction de changement de mot de passe 
function changePassword(form){
  if(form.newPwd == form.newPwd2){
    this.axios.post(conf.server+"/api/changePassword",form ,{withCredentials:true})
    .then(() => {
      alert("Votre mot de passe à été changé vous allez être redirigé vers la page de login")
      this.axios.post(conf.server+"/api/disconnect",{},{withCredentials:true})
      .then((response) => {
        this.$router.push(response.data.route);
      })
      .catch(() => {
        this.$router.push('/');
      })
    })
    .catch((error) => {
    if(error.response != undefined){
      toasterError(error.response,'Changement de mot de passe')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
    })
  }else{
    toasterError(`Les mots de passe ne correspondent pas`,'Changement de mot de passe')
  }
}

//Changement de la vitesse du carrousel
function changeSpeed(){
  this.axios.post(conf.server+"/api/changeConfCarrousel",{vitesse: this.confCarrousel.vitesse},{withCredentials:true})
  .then(() => {
    alert("Vitesse du carrousel changée");
  })
  .catch((error) => {
    if(error.response != undefined){
      toasterError(`Changement de vitesse du carrousel impossible`,'Changement de vitesse')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de choix de produit
function chooseProduct (item) {
  this.axios.get(conf.server+"/api/getProduct/"+item.value,{withCredentials:true})
  .then((response) => {
    var resProduct = response.data
    this.product[0].id = resProduct.id
    this.product[0].ref = resProduct.ref
    this.product[0].description = resProduct.description
    this.product[0].label = resProduct.label
    this.product[0].tva = resProduct.tva
    this.product[0].prixUnitaire = Number.parseFloat(resProduct.price).toFixed(2)
    this.product[0].qty = '1'
    this.product[0].reduction = ""
    this.product[0].type = resProduct.type
  })
  .catch((error) => {
    if(error.response != undefined){
      toasterError(`Le produit est inexistant`,'Recherche de produit')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de commentaire sur le document client
function commentDoc(){
  //console.log(doc);
}

//fonction de création de propale
function createPropal(){
  this.axios.post(conf.server+"/api/createPropal",{form: this.form, products: this.products},{withCredentials:true})
    .then(() => {
      this.$bvToast.toast(`Création de proposition commerciale réussie`, {
        title: 'Création de proposition commerciale',
        toaster: 'b-toaster-bottom-right',
        variant: 'success',
        autoHideDelay: 2500,
        appendToast: true,
        solid: true
      })
      this.$router.push('../login')
    })
    .catch((error) => {
    if(error.response != undefined){
      toasterError(`Impossible de créer la proposition commerciale`,'Création de proposition commerciale')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
    })
}

//Suppression d'une image du carrousel
function deleteImg(chemin){
  this.axios.post(conf.server+"/api/deleteImg",{chemin: chemin},{withCredentials:true})
  .then(() => {
    window.location.reload();
  })
  .catch((error) => {
    if(error.response != undefined){
      toasterError(`Impossible de supprimer l'image`,'CSuppression d\'image')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de suppression de produit à ajouter
function deleteProduct () {
  this.product[0].id = ''
  this.product[0].ref = ''
  this.product[0].description =  ''
  this.product[0].label =  ''
  this.product[0].tva = '20.000'
  this.product[0].prixUnitaire = ''
  this.product[0].qty = '1'
  this.product[0].reduction = ''
  this.productSearch = ''
  this.limitedService.start = ''
  this.limitedService.finish = ''
}

//Fonction de suppression de produit devis
function deleteProducts (item) {
  this.products.splice(item.index,1)
}

//Fonction de déconnexion
async function disconnect() {
  var disconnected = confirm("Voulez-vous vous déconnecter?");
  if(disconnected == true){
    try {
      await requestApi({method: 'POST', url: '/api/disconnect?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
      this.$router.push('/')
    } catch (error) {
      console.log(error)
      this.$router.push('/')
    }
    // this.axios.post(conf.server+"/api/disconnect",{},{withCredentials:true})
    // .then(() => {
    //   this.$router.push('/');
    // })
    // .catch(() => {
    //   this.$router.push('/');
    // })
  }
}



//Fonction de récupération des infos perso du client
function getInfoClient(){
  this.axios.get(conf.server+"/api/getInfoPersoClient",{withCredentials:true})
    .then((response) => {
      this.infoClients = response.data;
      this.infoPerso = JSON.parse(JSON.stringify(this.infoClients));
    })
    .catch((error) => {
      if(error.response != undefined){
        toasterError(`Impossible de charger les informations client`,'Chargement des infos')
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
}

//Fonction de récupération des infos de la société du client
function getInfoSocClient(){
  this.axios.get(conf.server+"/api/getInfoSocClient",{withCredentials:true})
  .then((response) => {
    this.infoSocClient = response.data;
  })
  .catch((error) => {
    if(error.response != undefined){
      toasterError(`Impossible de charger les informations de la société`,'chargement des infos de société')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de génération des infos à envoyer au client  
function info(row,target) {
  this.form.email=row.email;
  this.modalInfo.title = 'Contact: '+row.firstname+' '+row.lastname;
  this.axios.post(conf.server+"/api/passwordGenerator",{email: row.email},{withCredentials:true})
  .then((response) => {
    this.pwd = response.data.pwd;
    this.tokenReinit = response.data.tokenReinit;
    this.loadingTemplateMail(this.templateSelected,this.form.email,this.pwd,this.tokenReinit);
  })
  .catch((error) => {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
  this.$root.$emit('bv::show::modal', 'modalInfo',target);
}

//Fonction de vérification de connexion pour la page login
//Si l'utilisateur est connecté il est redirigé vers la page index
function isConnect(){
  this.axios.post(conf.server+"/api/isConnect",{},{withCredentials:true})
  .then((response) => {
    if(response.status==200){
      this.$router.push(response.data.route);
    }else{
      this.$router.push('login');
    }
  })
  .catch(() => {
    this.$router.push('login');
  })
}

//Fonction pour itérer massive contact
function iterateMassiveContact(user,template){
  var email = user.email;
  var nom = user.lastname;
  var prenom = user.firstname;
  this.axios.post(conf.server+"/api/passwordGenerator",{email:email},{withCredentials:true})
  .then((response) => {
    var pwd = response.data.pwd;
    var tokenReinit = response.data.tokenReinit;
    this.axios.post(conf.server+"/api/getInfoClient",{email:email},{withCredentials:true})
    .then((response2) => {
      var ref = response2.data.ref_entreprise;
      var nomEntreprise = response2.data.nom_entreprise;
      this.axios.post(conf.server+"/api/template",{template:template, email:email, pwd: pwd, tokenReinit:tokenReinit, prenom:prenom, nom:nom, ref:ref, nomEntreprise:nomEntreprise},{withCredentials:true})
      .then((response3) => {
        this.axios.post(conf.server+"/api/createAccess",{email:email, pwd:pwd, tokenReinit:tokenReinit, contenuMail:response3.data},{withCredentials:true})
        .then(() => {
          this.$refs.modalAjoutExtranet.hide();
        })
        .catch((error4)=>{
          if(error4.response != undefined){
            toasterError(`Impossible de créer l'accès à l'extranet`,'Création d\'accès')
          }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
          }      
        })
      })
      .catch((error3)=>{
      if(error3.response != undefined){
        toasterError(`Impossible de charger le contenu du mail`,'Chargement du contenu du mail')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
      })
    })
    .catch((error2)=>{
      if(error2.response != undefined){
        toasterError(`Impossible de charger les infos du client`,'Chargement des infos')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
  })
  .catch((error)=>{
    if(error.response != undefined){
      toasterError(`Impossible de générer les mot de passe aléatoire`,'Génération de mot de passe')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Ajouter un ordre pour les images!!!!!!!!!!!!!!!!
//Chargement des images du carrousel
function loadCarrousel(){
  this.axios.get(conf.server+"/api/imagesCarrousel",{withCredentials:true})
  .then((response) => {
    for(var i=0; i<response.data.length;i++){
      var tmp = {chemin_img:response.data[i].chemin_img}
      this.imgCarrousel.push(tmp);
    }
    this.totalRows=response.data.length;
  })
  .catch((error) => {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de chargement des documents du client
async function loadDocuments(type){
  var param
  if(this.$route.params.id !== undefined){
    param = {
      type:type,
      id:this.$route.params.id
    }
  }else{
    param = {
      type:type,
      id:0
    }
  }
  var i
  let documents
      switch(type){
        case 'contracts':
          documents = await requestApi({method: 'GET', url: '/api/getContracts?nocache=' + new Date().getTime(), params: param, form: {}, headers: {'Content-Type': 'application/json'}})
          for(i=0;i<documents.length;i++){
            let contract = documents[i]
            contract.date_creation = moment(contract.date_creation*1000).format("DD-MM-YYYY")
            contract.date_signature = moment(contract.array_options.options_ec_signature_date*1000).format("DD-MM-YYYY")
            contract.date_effective = moment(contract.array_options.options_ec_effective_date*1000).format("DD-MM-YYYY")
            contract.total_ht = new Intl.NumberFormat(0, { style: 'currency', currency: 'EUR' }).format(contract.total_ht)
            contract.total_ttc = new Intl.NumberFormat(0, { style: 'currency', currency: 'EUR' }).format(contract.total_ttc)
            vuexStorage.commit("addContract", contract)
          }
        break;
        case 'proposals':
          documents = await requestApi({method: 'GET', url: '/api/getProposals?nocache=' + new Date().getTime(), params: param, form: {}, headers: {'Content-Type': 'application/json'}})
          for(i=0;i<documents.length;i++){
            let proposal = documents[i]
            proposal.date_creation = moment(proposal.date_creation*1000).format("DD-MM-YYYY");
            proposal.total_ht = new Intl.NumberFormat(0, { style: 'currency', currency: proposal.multicurrency_code }).format(proposal.total_ht);
            proposal.total_ttc = new Intl.NumberFormat(0, { style: 'currency', currency: proposal.multicurrency_code }).format(proposal.total_ttc);
            vuexStorage.commit("addProposal", proposal)
          }
          break;
        case 'orders':
          documents = await requestApi({method: 'GET', url: '/api/getOrders?nocache=' + new Date().getTime(), params: param, form: {}, headers: {'Content-Type': 'application/json'}})
          for(i=0;i<documents.length;i++){
            let order = documents[i]
            order.date_commande = moment(order.date_commande*1000).format("DD-MM-YYYY");
            if(order.date_livraison!=""){
              order.date_livraison = moment(order.date_livraison*1000).format("DD-MM-YYYY");
            }else{
              order.date_livraison = false;
            }
      
            order.total_ht = new Intl.NumberFormat(0, { style: 'currency', currency: order.multicurrency_code }).format(order.total_ht);
            order.total_ttc = new Intl.NumberFormat(0, { style: 'currency', currency: order.multicurrency_code }).format(order.total_ttc);
            vuexStorage.commit("addOrder", order)
          }
          break;
        case 'invoices':
          documents = await requestApi({method: 'GET', url: '/api/getInvoices?nocache=' + new Date().getTime(), params: param, form: {}, headers: {'Content-Type': 'application/json'}})
          for(i=0;i<documents.length;i++){
            let invoice = documents[i]
            invoice.date_creation = moment(invoice.date_creation*1000).format("DD-MM-YYYY");
            invoice.date_lim_reglement = moment(invoice.date_lim_reglement*1000).format("DD-MM-YYYY");
            var now = Date.now();
            if(now>(invoice.date_lim_reglement*1000)){
              invoice.date_lim_sup = 1;
            }else{
              invoice.date_lim_sup = 0;
            }
            invoice.total_ht = new Intl.NumberFormat(0, { style: 'currency', currency: invoice.multicurrency_code }).format(invoice.total_ht);
            invoice.total_ttc = new Intl.NumberFormat(0, { style: 'currency', currency:invoice.multicurrency_code }).format(invoice.total_ttc);
            vuexStorage.commit("addInvoice", invoice)
          }
          break;
      }
}

//Fonction de chargement du nom et prenom
function loadingInfo(){
  this.axios.post(conf.server+"/api/loadingInfo",{},{withCredentials:true})
  .then((response) => {
    if(response.status==200){
      vuexStorage.commit('updateInfo', response.data)
    }else{
      this.$router.push('/');
    }
  })
  .catch(() => {
    this.axios.post(conf.server+"/api/disconnect",{},{withCredentials:true})
    .then((response) => {
      this.$router.push(response.data.route);
    })
    .catch(() => {
      this.$router.push('/');
    })
  })
}

//Fonction de changement d'entreprise multisite
async function changeTiers(tiers,socname){
  try {
    let response = await requestApi({method: 'POST', url: '/api/changeTiers', params: {}, form: {socid:tiers.socid,socname:socname}, headers: {'Content-Type': 'application/json'}})
    this.$router.push("/");
  } catch (error) {
    console.log(error)
  }
}

//Fonction de choix du template mail d'envoie de code d'accès
function loadingTemplateMail(template,email,pwd,tokenReinit){
  this.axios.post(conf.server+"/api/getInfoClient",{email: email},{withCredentials:true})
  .then((response) => {
    this.axios.post(conf.server+"/api/template",{template : template,email: email,pwd : pwd,tokenReinit: tokenReinit, prenom : response.data.firstname, nom : response.data.lastname, ref : response.data.ref_entreprise, nomEntreprise : response.data.nom_entreprise},{withCredentials:true})
    .then((response2) => {
      this.form.contenuMail=response2.data.content;
    })
    .catch((error) => {
      if(error.response != undefined){
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }else{
          this.$router.push('/');
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
  })
  .catch((error) => {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }else{
        this.$router.push('/');
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de chargement des templates mail
function loadingTemplatesMail(){
  this.axios.post(conf.server+"/api/templates",{},{withCredentials:true})
  .then((response) => {
    var templateBase = {value:null, text: 'Template de base',active:1}
    this.templates.push(templateBase);
    for(var i=0; i<response.data.length;i++){
      var tmp = {value:response.data[i].value, text:response.data[i].text, active:response.data[i].active}
      this.templates.push(tmp);
    }
  })
  .catch((error) => {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }else{
        this.$router.push('/');
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de chargement des templates mail actif
function loadingTemplatesMailActive(){
  this.axios.get(conf.server+"/api/templatesActive",{},{withCredentials:true})
  .then((response) => {
    var templateBase = {value:null, text: 'Template de base'}
    this.templates.push(templateBase);
    for(var i=0; i<response.data.length;i++){
      var tmp = {value:response.data[i].value, text:response.data[i].text}
      this.templates.push(tmp);
    }
  })
  .catch((error) => {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }else{
        this.$router.push('/');
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Chargement de la vitesse du carrousel
function loadSpeed(){
  this.axios.get(conf.server+"/api/loadConfCarrousel",{withCredentials:true})
  .then((response) => {
    for(var i=0; i<response.data.length;i++){
      if(response.data[i].name=="CARROUSEL_TIMEOUT"){
        this.confCarrousel.vitesse = response.data[i].value;
      }
    }
  })
  .catch((error) => {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction d'affichage du modal de modification des infos perso du client
function modifInfoPerso(target){
  this.$root.$emit('bv::show::modal', 'modalInfoPerso',target);
}

//Fonction réinitialisation du modal
function resetModal() {
  this.modalInfo.title = ''
  this.modalInfo.content = ''
}

//Fonction de chargement de produit
async function searchProducts(querystring){
  let search = querystring
  try {
		let products = await requestApi({method: 'GET', url: '/api/searchProduct?nocache=' + new Date().getTime(), params: {search: search}, form: {}, headers: {'Content-Type': 'application/json'}})
    let res = []
    products.forEach(async element => {
      let marque = ""
      if(element.array_options){
        if(element.array_options.option_marque){
          marque = element.array_options.option_marque
        }
      }
      let prixHT = Number.parseFloat(element.price).toFixed(2)
      let prixTTC = Number.parseFloat(element.price_ttc).toFixed(2)
      let tauxTVA = Number.parseFloat(element.tva_tx).toFixed(2)
      try {
        let documents = await requestApi({method: 'GET', url: '/api/getProductDocuments?nocache=' + new Date().getTime(), params: {id: element.id}, form: {}, headers: {'Content-Type': 'application/json'}})
        let images = []
        documents.forEach(document => {
          if((document.name.split('.').pop() == "jpeg") || (document.name.split('.').pop() == "png") || (document.name.split('.').pop() == "jpg")){
            images.push({
              name: document.name,
              path: document.fullname,
              encodedURI: encodeURI(document.fullname)
            })
          }
        })
        res.push({
          id: element.id,
          value: element.label,
          marque: marque,
          description: element.description,
          ref:element.ref,
          prixHT: prixHT,
          prixTTC: prixTTC,
          tauxTVA: tauxTVA,
          documents: documents,
          images: images,
          details: element 
        })
      } catch (error) {
        if(error.response != undefined){
          if(error.response.status == 401 || error.response.status == 400){
            console.log(error)
            this.$router.push('/');
          }else if(error.response.status == 404){
            res.push({
              id: element.id,
              value: element.label,
              marque: marque,
              description: element.description,
              ref:element.ref,
              prixHT: prixHT,
              prixTTC: prixTTC,
              tauxTVA: tauxTVA,
              documents: [],
              images: [],
              details: element
            })
          }
        }else{
          console.log(error)
          toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      }
    })
    return res
	} catch (error) {
		if(error.response != undefined){
			if(error.response.status == 401 || error.response.status == 400){
				this.$router.push('/');
			}
			toasterError(`Aucun produit n'a été trouvé`,`Recherche de produit`)
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Fonction change password
function setPass(){
  if(this.post.pwd==this.post.pwd2){
    this.axios.post(conf.server+"/api/setPass", {pwd:this.post.pwd,token:this.$route.params.token},{withCredentials:true})
    .then((response) => {
      if(response.status==200){
        this.$bvToast.toast(`Changement mot de passe réussi`, {
          title: 'Changement de mot de passe',
          toaster: 'b-toaster-bottom-right',
          variant: 'success',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        })
        this.$router.push("../login");
      }else{
        this.$router.push("../login");
      }
    })
    .catch((error) => {
      if(error.response != undefined){
        toasterError(`Changement de mot de passe impossible`,'Changement de mot de passe')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
  }else{
    toasterError(`Les deux mots de passes ne correspondent pas`,'Changement de mot de passe')
  }
}

//Upload des images du carrousel
function uploadImg(){
  var myfile = document.getElementById("myfile").files;

  var formData = new FormData();

  var files = new Array();

  for(var i=0; i < myfile.length; i++){
    formData.append('myfile', myfile[i]);
    var tmp = {name:myfile[i].name};
    files.push(tmp);
  }
  this.axios.post(conf.server+"/api/uploadFilesCarrousel",formData,{headers:{"content-type" : "multipart/form-data"},withCredentials:true})
  .then(() => {
    this.axios.post(conf.server+"/api/addImg",files,{withCredentials:true})
    .then(() => {
      window.location.reload();
    })
    .catch((error) => {
      if(error.response != undefined){
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
  })
  .catch((error) => {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de vérification des droits de l'utilisateur
function verifyRight(){
  this.axios.post(conf.server+"/api/verifyRight",{route: this.$route.name},{withCredentials:true})
  .then(() => {
    
  })
  .catch((error) => {
    if(error.response != undefined){
      if(error.response.status==403){
        this.$router.push('error403');
      }else{
        this.axios.post(conf.server+"/api/disconnect",{},{withCredentials:true})
        .then(() => {
          window.location = "https://aloha-espacecom.ideal2s.net";
        })
        .catch(() => {
          window.location = "https://aloha-espacecom.ideal2s.net";
        })
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de vérification de token
function verifyToken(){
  this.axios.get(conf.server+"/api/verifyToken/"+this.$route.params.token,{withCredentials:true})
  .then((response) => {
    if(!response.data){
      toasterError(`Temps pour changer de mot de passe écoulé`,'Vérification')
      this.$router.push("../login");
    }
  })
  .catch(()=>{
    toasterError(`Temps pour changer de mot de passe écoulé`,'Vérification')
    this.$router.push("../login");
  })
}

//Fonction de visualisation des document client
function visualDoc(item,target){
  if(item.last_main_doc!=null){
    this.axios.get(conf.server+"/api/visualDoc/"+item.last_main_doc,{withCredentials:true})
    .then(() => {
      this.visualSrc = conf.server+"/api/visualDoc/"+item.last_main_doc;
      this.modalVisual.title="Document "+item.ref+" : "+item.ref_client+" du "+item.date_creation;
      this.$root.$emit('bv::show::modal', 'modalVisual',target);
    })
    .catch(() => {
      toasterError(`Visualisation du document impossible`,'Visualisation du document')
    }) 
  }else{
    this.axios.get(conf.server+"/api/visualDoc/contract/"+item.ref+"/"+item.ref+'.pdf',{withCredentials:true})
    .then(() => {
      this.visualSrc = conf.server+"/api/visualDoc/contract/"+item.ref+"/"+item.ref+'.pdf';
      this.modalVisual.title="Document "+item.ref+" : "+item.ref_customer+" du "+item.date_creation;
      this.$root.$emit('bv::show::modal', 'modalVisual',target);
    })
    .catch(() => {
      toasterError(`Visualisation du document impossible`,'Visualisation du document')
    }) 
  }
}

//Fonction de visualisation des document client
function visualDocClient(item,target){
  if(item.last_main_doc!=null){
    var lastMainDoc = item.last_main_doc.split('/')
    this.axios.get(conf.server+"/api/visualDoc/"+item.last_main_doc,{withCredentials:true})
    .then(() => {
      this.visualSrc = conf.server+"/api/visualDoc/"+item.last_main_doc;
      this.modalVisual.title="Document "+item.ref+" : "+item.ref_client+" du "+item.date_creation;
      switch (lastMainDoc[0]) {
        case "facture":
          this.$root.$emit('bv::show::modal', 'modalVisualFactures',target);
          break;
        case "propale":
          this.$root.$emit('bv::show::modal', 'modalVisualDevis',target);
          break;
        case "commande":
          this.$root.$emit('bv::show::modal', 'modalVisualCommandes',target);
          break;
      
        default:
          break;
      }
      this.$root.$emit('bv::show::modal', 'modalVisual',target);
    })
    .catch(() => {
      toasterError(`Visualisation du document impossible`,'Visualisation du document')
    }) 
  }else{
    this.axios.get(conf.server+"/api/visualDoc/contract/"+item.ref+"/"+item.ref+'.pdf',{withCredentials:true})
    .then(() => {
      this.visualSrc = conf.server+"/api/visualDoc/contract/"+item.ref+"/"+item.ref+'.pdf';
      this.modalVisual.title="Document "+item.ref+" : "+item.ref_customer+" du "+item.date_creation;
      this.$root.$emit('bv::show::modal', 'modalVisualContrats',target);
    })
    .catch(() => {
      toasterError(`Visualisation du document impossible`,'Visualisation du document')
    }) 
  }
}

//Fonction de visualisation des templates mail
function visualiserTemplate(title,template,target){
  this.axios.post(conf.server+"/api/templateVisual",{template : template},{withCredentials:true})
    .then((response) => {
      this.modalVisualTemplate.title=title;
      this.modalVisualTemplate.content=response.data.content;
      this.$root.$emit('bv::show::modal', 'modalVisualTemplate',target);
    })
    .catch((error) => {
      if(error.response != undefined){
        toasterError(`Impossible de charger la visualisation du template`,'Visualisation impossible')
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
}

//Fonction d'ajout de produit dans un devis fk_product, label, qty, tva_tx, product_type, subprice

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default {
  changeTiers,
  disconnect,
  loadingInfo,
  isConnect,
  verifyRight,
  info,
  resetModal,
  loadingTemplatesMailActive,
  loadingTemplatesMail,
  loadingTemplateMail,
  loadDocuments,
  visualDoc,
  visualDocClient,
  commentDoc,
  getInfoClient,
  getInfoSocClient,
  changePassword,
  modifInfoPerso,
  changeInfoPerso,
  activeClassMenuProfil,
  visualiserTemplate,
  activerTemplate,
  loadCarrousel,
  uploadImg,
  changeSpeed,
  loadSpeed,
  deleteImg,
  changePassOublie,
  verifyToken,
  setPass,
  createPropal,
  searchProducts,
  addProduct,
  chooseProduct,
  deleteProduct,
  deleteProducts,
  toasterError,
  toasterSuccess,
};
